<template>
    <div class="container">
        <div class="panel panel-head hard-border">
            <div class="project-information">
                <h5>
                    Account
                    <div class="number" v-text="user.name"></div>
                </h5>
            </div>
            <div class="btn-actions">
                <button class="btn btn-success" :disabled="form.isSubmitted" @click="save()">
                    <span v-if="form.isSubmitted">
                        <i class="fa fa-spin fa-spinner"></i> Updating
                    </span>
                    <span v-else>
                        <i class="fa fa-save"></i> Update
                    </span>
                </button>
                <button class="btn btn-orange" @click="loginAs()" v-if="authorize('admin') && notAuthUser">
                    <i class="fa fa-lock"></i> Login As
                </button>
                <a href="/users" class="btn btn-default" v-if="authorize('admin') && notAuthUser">
                    <i class="fa fa-users"></i> Users Page
                </a>
            </div>
        </div>
        <form action="#">
            <div class="card panel hard-border panel-body">
                <user-form :form="form"></user-form>
            </div>
        </form>
    </div>
</template>
<script>

    let Roles = require('@/mixins/Management/Roles')

    export default {

        mixins: [Roles],

        props: {
            user: {
                type: Object,
                required: true,
            },
        },

        data(){
            return {
                form: new Form(_.merge(this.user, {
                    password: '',
                    password_confirmation: '',
                }), false),
            }
        },

        methods: {

            save(){
                this.form.put(`/account/${this.user.slug}`).then(response => {
                    Alert.success('The user has been updated!')
                }).catch(errors => {
                    Alert.error(errors.first())
                })
            },

            loginAs() {
                axios.post(`/management/users/${this.user.slug}/sign-in-as`).then(response => {
                    this.redirectTo('/');
                })
            },
        },

        computed:{
            notAuthUser(){
                return this.user.id != App.config.userId;
            }
        }
    }
</script>
